export const environment = {
  production: true,
  apiUrl: '/api/',
  webUrl: 'https://futuristiclevelz.io/',
  travelUrl: '/travel-app',
  storeUrl: '/ecommerce',
  mapboxAccessToken: 'pk.eyJ1IjoiaDJvMjYiLCJhIjoiY21weHZyMWFxMDAybTJxb25zNHd4emdpbCJ9.5NzlWjFGiJc4eyW4geZN7Q',
  agoraServeArea:'GLOBAL',
  agoraAppId: '0c22c1f37c054115aea53c34399dab27',
  coinbaseUrl: 'https://www.coinbase.com/join/clark_rer',
  newsFeed: 'https://www.youtube.com/embed/RmmRlztXETI?controls=0&autoplay=1',
  stripePublicKey: 'pk_test_51SoWCTDKMYVdczhkZVJvdy3co58n6xXytF5VtyIrj4pYJGwodJeQBcWYlxBxqyWNUHEisemxHN0Y3ZFWWilzpVB900eLw5KTrA' // Replace with your actual Stripe public key
};
